import {
    actionSetUserFeatureMap,
} from '@/app/shared/utils/stateActionUtils';

import {
    SET_PANEL,
    SET_STATES,
    SET_TYPES,
    SET_FILTERS_MAP,
    UPDATE_FILTER_ITEM_MAP,
} from './mutation-types';

const actions = {
    setPanels ({ commit, dispatch }, panels){
        if(panels){
            for(let e=0, elen=panels.length; e<elen; e++){
                let panel = panels[e];
                if(panel.id){
                    dispatch('setPanel', panel);
                }
            }
        }
    },
    setPanel ({ commit, state }, {id, ...params}){
        commit(SET_PANEL, {id, ...params});
    },
    openPanel ({ commit, state }, id){
        commit(SET_PANEL, {id, show: true});
    },
    closePanel ({ commit, state }, id){
        commit(SET_PANEL, {id, show: false});
    },
    togglePanel ({ commit, state, getters }, id){
        commit(SET_PANEL, {id, show: !getters.getPanelStatus(id)});
    },
    closeAllPanels ({ commit, state, getters }){
        let panels = getters.getPanels;
        for(let e=0, elen=panels.length; e<elen; e++){
            let panel = panels[e];
            if(panel.id){
                if(panel.showDefault !== undefined && panel.showDefault){
                    continue;
                }
                commit(SET_PANEL, {id: panel.id, show: false});
            }
        }
    },
    setStates ({ commit }, states) {
         commit(SET_STATES, states);
    },
    setTypes ({ commit }, types) {
         commit(SET_TYPES, types);
    },
    async setUserFeatureMap ({ commit }, feature) {
        await actionSetUserFeatureMap(this._vm, commit, feature);
    },
    setFiltersMap ({ commit, state }, filters){
        commit(SET_FILTERS_MAP, filters);
    },
    async toggleFilterMap ({ commit, state }, {tp, id}){
        let item = state.data.map.filters[tp].find( item => item.id == id);
        let show = !item.show;
        commit(UPDATE_FILTER_ITEM_MAP, {tp: tp, id: id, show: show});
        let sub_items = tp=='status' ? item.types : item.status;
        for(let sub_id in sub_items){
            let qty = sub_items[sub_id];
            if(qty){
                let state_items = tp=='status' ? state.data.map.filters.types : state.data.map.filters.status;
                let state_item = state_items.find(item => item.id == parseInt(sub_id));
                if(state_item && state_item.qty !== 'undefined'){
                    // state_item.qty = item.show ? state_item.qty + qty : state_item.qty - qty;
                    let new_qty = item.show ? state_item.qty + qty : state_item.qty - qty;
                    commit(UPDATE_FILTER_ITEM_MAP, {tp: 'types', item: state_item, qty: new_qty});
                }
            }
        }
    },
    updateFilterMap ({ commit, state }, obj){
        Object.entries(obj).forEach(([tp, val]) => {
            let from = val.from;
            let to = val.to;
            if(from && to && from!=to){
                let f_item = state.data.map.filters[tp].find(e => e.id == from)
                let t_item = state.data.map.filters[tp].find(e => e.id == to)
                commit(UPDATE_FILTER_ITEM_MAP, {tp: tp, item: f_item, qty: f_item.qty-1});
                commit(UPDATE_FILTER_ITEM_MAP, {tp: tp, item: t_item, qty: t_item ? t_item.qty + 1 : 1});
            }
        });
    },
    toggleCollapseFilterMap ({ commit, state, getters }, id){
        commit(SET_PANEL, {id, collapsed: !getters.getPanel(id).collapsed});
    },
};

export default actions;
